import request from '@/utils/request'

// 查询新闻管理列表
export function listNews(query) {
  return request({
    url: '/api/news/list',
    method: 'get',
    params: query
  })
}

// 查询新闻管理详细
export function getNews(newsId) {
  return request({
    url: '/api/news/' + newsId,
    method: 'get'
  })
}